import './mergeable_profile_view.js.coffee'

Namespace 'Customer.Users'

class Customer.Users.MainMergeableProfileView extends Customer.Users.MergeableProfileView
  className: 'mergeable-profile main-profile'

  _applyStyle: =>
    @$el.find('.header').css('background-color', window.color_for(@socialNetworkName()))

  toggleChecked: ->

  isChecked: ->
    true

  _shouldSelectAttribute: ->
    true

  getSocialUsersToMerge: ->
    []
